(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csyt-cafe-product"] && !Shopify.designMode) return;
  try {
    
/* ── Animación de barras del perfil sensorial ── */
(function () {
'use strict';
const SECTION_ID = 'csy-cafe-section-{{ section.id }}';

function animateBars(section) {
section.querySelectorAll('.csy-cafe-bar-fill').forEach(function (bar) {
bar.classList.add('csy-cafe-bar--animated');
});
}

function init() {
var section = document.getElementById(SECTION_ID);
if (!section) return;

if ('IntersectionObserver' in window) {
var sensoryBlock = section.querySelector('.csy-cafe-sensory');
if (!sensoryBlock) return;

var observer = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting) {
animateBars(sensoryBlock);
observer.disconnect();
}
});
}, { threshold: 0.2 });

observer.observe(sensoryBlock);
} else {
animateBars(section);
}
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
